import { render, staticRenderFns } from "./ProductCarouselSmartSearch.vue?vue&type=template&id=2bf028a4"
import script from "./ProductCarouselSmartSearch.vue?vue&type=script&lang=js"
export * from "./ProductCarouselSmartSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports